<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewCursoSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-curso-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Agregar Nuevo Curso
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Nombre de Curso -->
          <validation-provider
            #default="validationContext"
            name="Nombre de Curso"
            rules="required"
          >
            <b-form-group
              label="Nombre de Curso"
              label-for="nombre-curso"
            >
              <b-form-input
                id="nombre-curso"
                v-model="cursoData.nombre"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Vue.js"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Estado de Curso (activo, inactivo) -->
          <validation-provider
            #default="validationContext"
            name="Estado"
            rules="required"
          >
            <b-form-group
              label="Estado"
              label-for="estado"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="cursoData.estado"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="estado"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- descripción -->
          <label for="descripcion">Descripción</label>
          <b-form-textarea
            id="descripcion"
            v-model="cursoData.descripcion"
            placeholder="Descripción del Curso"
            rows="2"
          />

          <!-- Categoria Curso -->
          <validation-provider
            #default="validationContext"
            name="Categoria"
            rules="required"
          >
            <b-form-group
              label="Categoria"
              label-for="curso-categoria"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="cursoData.categorias"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categoriaOptions"
                :reduce="val => val.id"
                :clearable="false"
                multiple
                input-id="curso-categoria"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Carrera Curso -->
          <validation-provider
            #default="validationContext"
            name="Carrera"
            rules="required"
          >
            <b-form-group
              label="Carrera"
              label-for="carrera"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="cursoData.carreras"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="carreraOptions"
                :reduce="val => val.id"
                :clearable="false"
                multiple
                input-id="carrera"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Guardar Curso
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
// import store from '@/store'
import { useMutation } from '@vue/apollo-composable'
import ADD_CURSO from '../../../../graphql/cursos/curso/AddCurso.gql'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewCursoSidebarActive',
    event: 'update:is-add-new-curso-sidebar-active',
  },
  props: {
    isAddNewCursoSidebarActive: {
      type: Boolean,
      required: true,
    },
    categoriaOptions: {
      type: Array,
      required: true,
    },
    carreraOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  setup(props, { emit }) {
    // Use toast
    const toast = useToast()

    const blankCursoData = {
      nombre: '',
      estado: '',
      descripcion: '',
      categorias: null,
      carreras: null,
    }

    const cursoData = ref(JSON.parse(JSON.stringify(blankCursoData)))
    const resetuserData = () => {
      cursoData.value = JSON.parse(JSON.stringify(blankCursoData))
    }

    const { mutate: sendCurso, onDone, onError } = useMutation(ADD_CURSO, () => ({
      variables: cursoData.value,
    }))

    onDone(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Curso Registrado',
          icon: 'AlertTriangleIcon',
          variant: 'success',
        },
      })
    })

    onError(error => {
      toast({
        component: ToastificationContent,
        props: {
          title: error.message,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })

    const onSubmit = () => {
      sendCurso()

      emit('refetch-data')
      emit('update:is-add-new-curso-sidebar-active', false)
      /*
      store.dispatch('app-user/addUser', cursoData.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-user-sidebar-active', false)
        })
        */
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      cursoData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
